import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import store from './store'
import router from './router'
import i18n from './i18n'
import 'mint-ui/lib/style.css'
import { Actionsheet, DatetimePicker, Toast, Popup } from 'mint-ui'

import ElementUI from 'element-ui'

import mixin from '@/utils/mixin'

import wx from 'weixin-js-sdk'

Vue.component(Actionsheet.name, Actionsheet)
Vue.component(Popup.name, Popup)
Vue.component(DatetimePicker.name, DatetimePicker)

import vConsole from 'vconsole'
if(process.env.NODE_ENV === 'dev') {
  // new vConsole()
}

Vue.$toast = Vue.prototype.$toast = Toast


const requireComponent = require.context('./components/template', true, /[a-z]\w+\.(vue|js)$/)
// eslint-disable-next-line camelcase
let registerTemplateName_SAVE = []
requireComponent.keys().forEach(fileName => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName)
  // const componentName = fileName.toLowerCase().split('/').pop().replace(/\.\w+$/, '')
  const componentName = 'C' + componentConfig.default.uuid.replace(/-/g, '')
  registerTemplateName_SAVE.push(componentName)
  // 全局注册组件
  Vue.component(
    componentName,
    // 如果这个组件选项是通过 `export default` 导出的，
    // 那么就会优先使用 `.default`，
    // 否则回退到使用模块的根。
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false
Vue.mixin(mixin({registerTemplateName_SAVE}))
Vue.config.productionTip = false

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

window.MPApp = new Vue({
  store,
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')

// new Vue({
//   el: '#app',
//   i18n,
//   router,
//   components: { App },
//   template: '<App/>'
// })

